import { call, put } from 'redux-saga/effects';
import FMI_ACTIONS from '../../../../actions';
import { transport } from '../../../../../config/transport';
import { toastHelper } from 'helpers/toastHelper';

export default function* getListOfCongDoanDanhMucThuChiDauNam(action) {
    yield put({ type: FMI_ACTIONS.LOADING_STATUS__LOADING });
    // This comment will be remove whenever we handle the jwt login process
    try {
        let { data } = yield call(callApiGetListOfCongDoanDanhMucThuChiDauNam);
        yield put({
            type: FMI_ACTIONS.CONGDOAN_GET_DANH_MUC_THUCHI_DAUNAM_SUCCESS,
            payload: { data },
        });
    } catch (e) {
        yield put({
            type: FMI_ACTIONS.CONGDOAN_CALL_FAIL,
        });
        toastHelper.error(e.message);
    }
    yield put({ type: FMI_ACTIONS.LOADING_STATUS__LOADED });
}

export function callApiGetListOfCongDoanDanhMucThuChiDauNam() {
    return transport.get(`/congdoan/thuchi/daunam/danhmuc`);
}
